import { Container } from 'react-bootstrap';
import {
    BannerUnSuperAlimento,
    BackGroundImageHero,
    FacebookPosts,
} from '../../components';
import './styles.scss';
import { Helmet } from 'react-helmet';

const MiToqueIsadora = () => {
    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>Mi toque Isadora | Frijoles Isadora</title>
                <meta name="description" content="Prácticos consejos que gente como tú nos comparte para darle un toquecito a sus frijoles Isadora." />             
                <link rel='canonical' href={window.location.href} />
                <style type='text/css'>
                    {`
                        .sr-only {
                            position: absolute;
                            width: 1px;
                            height: 1px;
                            padding: 0;
                            margin: -1px;
                            overflow: hidden;
                            clip: rect(0, 0, 0, 0);
                            white-space: nowrap;
                            border-width: 0;
                        }
                        
                    `}
                </style>
            </Helmet>
            <h1 className="sr-only">Mi toque Isadora</h1>
            <BackGroundImageHero />
            <section>
                <Container>
                    <div className='string_contents'>
                        <h2 className='miToqueIsadoraTitle'>
                            HAZLO ESPECIAL, <strong>PONLE TU TOQUE</strong>
                        </h2>
                        <div className='text'>
                            <p className='robotoReg'>
                                Sabemos que te encanta sorprender a tus seres
                                queridos con platillos que demuestren tu amor y
                                lleven tu huella. ¿Cuál es tu secreto para darle
                                una sazón especial a tus frijoles Isadora?
                            </p>
                            <div className='little_space'></div>
                            <p className='robotoReg'>
                                Compártelo y descubre lo que otras personas
                                hacen para transformar cada plato en algo único.
                            </p>
                        </div>
                    </div>
                </Container>
                <FacebookPosts />
            </section>
            <BannerUnSuperAlimento />
        </>
    );
};

export default MiToqueIsadora;
